import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { CVRSystem } from './components/CVRSystem';
import { ValueStack } from './components/ValueStack';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { PostValueCTA } from './components/PostValueCTA';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesNotification } from './components/SalesNotification';
function OrangeSeparator() {
  return <div className="w-full h-2 bg-brand-orange" data-id="element-0" />;
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '1630509478181816');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-white font-sans selection:bg-brand-orange/20 selection:text-brand-navy" data-id="element-1">
      <HeroSection data-id="element-2" />
      <div className="bg-[#FFF3ED] py-5 px-4 text-center" data-id="element-3">
        <p className="font-sans font-bold text-lg md:text-xl text-brand-navy tracking-wide" data-id="element-4">
          PAZ · CONTROL · CONEXIÓN · DESCANSO
        </p>
        <p className="text-xs text-slate-500 mt-1" data-id="element-5">
          Lo que el Método CVR devuelve a tu hogar.
        </p>
      </div>
      <PainPoints data-id="element-6" />
      <CVRSystem data-id="element-7" />
      <ValueStack data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <PostValueCTA data-id="element-11" />
      <OrangeSeparator data-id="element-12" />
      <Guarantee data-id="element-13" />
      <OrangeSeparator data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
      <SalesNotification data-id="element-17" />
    </main>;
}